<div class="history">
  <div class="history-header">History</div>
  <ul class="list">
    @for (item of items(); track item.id) {
      <li>
        <span class="timestamp me-2">{{ item.timestamp ? (item.timestamp | date:'short') : '' }}</span>
        <span>{{ item.text }}</span>
      </li>
    }
  </ul>
  <div class="hint small">More detailed history will appear here.</div>
</div>


